import { useEffect } from 'react';

// Carica lo script YouTube (solo una volta)
function loadYouTubeAPI(callback) {
  if (window.YT && window.YT.Player) return callback();
  const tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  window.onYouTubeIframeAPIReady = callback;
  document.body.appendChild(tag);
}

const MultiVideoManager = () => {
  useEffect(() => {
    let ytPlayers = [];
    let html5Videos = [];

    const pauseAllYouTube = () => ytPlayers.forEach((p) => p.pauseVideo?.());
    const pauseAllHTML5 = () => html5Videos.forEach((v) => v.pause());

    const setupHTML5Videos = () => {
      html5Videos = Array.from(document.querySelectorAll('video'));
      html5Videos.forEach((video) => {
        if (!video._multiVideoManaged) {
          video._multiVideoManaged = true;
          video.addEventListener('play', () => {
            pauseAllYouTube();
            html5Videos.forEach((v) => v !== video && v.pause());
          });
        }
      });
    };

    const setupYouTubePlayers = () => {
      const iframes = Array.from(
        document.querySelectorAll('iframe[src*="youtube.com/embed"]'),
      );
      iframes.forEach((iframe) => {
        if (iframe._multiVideoManaged) return;
        iframe._multiVideoManaged = true;

        let src = iframe.src;
        if (!src.includes('enablejsapi=1')) {
          const sep = src.includes('?') ? '&' : '?';
          iframe.src = src + sep + 'enablejsapi=1';
        }

        const player = new window.YT.Player(iframe, {
          events: {
            onStateChange: (ev) => {
              if (ev.data === window.YT.PlayerState.PLAYING) {
                pauseAllHTML5();
                ytPlayers.forEach((p) => p !== ev.target && p.pauseVideo());
              }
            },
          },
        });
        ytPlayers.push(player);
      });
    };

    const onMutations = () => {
      setupHTML5Videos();
      setupYouTubePlayers();
    };

    loadYouTubeAPI(() => onMutations());

    setupHTML5Videos();

    const observer = new MutationObserver(onMutations);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);

  return null;
};

export default MultiVideoManager;
